import { Mapper } from "../../../../base/utils/mapper";
import { ComercialModel } from "../../../../domain/models/comercial/comercial.model";
import { ComercialEntity } from "../entities/comercial.entity";


export class ComercialImplementationRepositoryMapper extends Mapper<ComercialEntity, ComercialModel> {
    mapFrom(param: ComercialEntity): ComercialModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: ComercialModel): ComercialEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}